import React from "react";
import iconZoomIn from "../../assets/icon/ic_video_zoom_in.svg";
import iconZoomOut from "../../assets/icon/ic_video_zoom_out.svg";
import styled from "styled-components";

const StyledVideoZoomButton = styled.div`
    height: 100%;
    cursor: pointer;
    
    display: inline-block;
    box-shadow: 0px 3px 6px #00000034;
    border-radius: 5px;
    width: 47px;
    height: 49px;
    background-color: #2CBFA3;
    position: relative;
    z-index: 10;
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    
    :hover {
        background-color: #109A7F;
    }
`;

interface IVideoZoomButton {
    zoom: boolean
}

const VideoZoomButton: React.FC<IVideoZoomButton> = (({zoom}) => {
    return (
        <StyledVideoZoomButton>
            <img src={zoom ? iconZoomOut : iconZoomIn} alt=""/>
        </StyledVideoZoomButton>
    )
});

export default VideoZoomButton;